<template>
  <div class="account-page-container">
    <div class="account-page-main">
      <el-card class="account-page-body" v-loading="isLoading">
        <div slot="header">
          <el-form :inline="true" :model="reqParams" size="mini" label-width="80px" class="search-params-form">
            <el-form-item label="姓名：">
              <el-input placeholder="请输入用户姓名" v-model="reqParams.userName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话：">
              <el-input placeholder="请输入用户手机号" v-model="reqParams.userPhone" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="类型：">
              <el-select v-model="reqParams.userType" clearable>
                <el-option v-for="utype in UserTypesArray" :key="utype.value" :label="utype.label" :value="utype.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="search-button">
                <el-button type="primary" @click="onSearch">查询</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div> <!-- end of header -->

        <div class="account-card-body">
          <div class="table-container">
            <el-table :data="staffInfoList" ref="configurationTable" border style="width: 100%" stripe size="mini" height="100%">
              <el-table-column label="姓名" min-width="100" align="center" property="userName"></el-table-column>
              <el-table-column label="电话" min-width="100" align="center" property="userPhone"></el-table-column>
              <el-table-column label="类型" min-width="100" align="center" property="userTypeSummary"></el-table-column>
              <el-table-column label="过期时间" min-width="100" align="center" property="expiryDateStr"></el-table-column>
              <el-table-column label="地块数限制" min-width="100" align="center" property="plotNumberLimit"></el-table-column>
              <el-table-column label="变更操作" align="center" min-width="200">
                <template slot-scope="scope">
                  <el-button @click="showUpdateUserTypeDialog(scope.row)" type="text" size="mini">用户类型</el-button>
                  <el-button @click="showUpdateUserExpiryDialog(scope.row)" type="text" size="mini">过期时间</el-button>
                  <el-button @click="showUpdateUserPlotLimitDialog(scope.row)" type="text" size="mini">地块限制</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="footer">
          <el-pagination
            background
            small
            @current-change="onChangePager"
            :current-page="reqParams.page"
            :page-size="reqParams.perPage"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-card>

      <!-- 更新用户类型 -->
      <div class="dialog-container">
        <el-dialog :visible.sync="updateUserTypeDialogVisible"
                   width="40%"
                   :show-close="true"
                   :before-close="onUpdateUserTypeDialogClose"
                   :close-on-click-modal="false"
                   center>
          <div class="dialog-main">
            <el-form :model="updateUserTypeParams" label-width="110px" class="search-params-form">
              <el-form-item :label="updateUserTypeParams.userName"/>
              <el-form-item label="用户类型：">
                <el-select v-model="updateUserTypeParams.userType">
                  <el-option
                    v-for="item in UserTypesArray"
                    v-if="item.value > 0"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="onUpdateUserTypeDialogClose()" type="primary">取消</el-button>
            <el-button @click="onUpdateUserType()" type="primary">确定</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 更新过期时间 -->
      <div class="dialog-container">
        <el-dialog :visible.sync="updateUserExpiryDialogVisible"
                   width="40%"
                   :show-close="true"
                   :before-close="onUpdateUserExpiryDialogClose"
                   :close-on-click-modal="false"
                   center>
          <div class="dialog-main">
            <el-form :model="updateUserExpiryParams" label-width="110px" class="search-params-form">
              <el-form-item :label="updateUserExpiryParams.userName"/>

              <el-form-item label="过期日期：">
                <el-date-picker
                  clearable
                  v-model="updateUserExpiryParams.expiryDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择过期日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="onUpdateUserExpiryDialogClose()" type="primary">取消</el-button>
            <el-button @click="onUpdateUserExpiry()" type="primary">确定</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 更新地块数限制 -->
      <div class="dialog-container">
        <el-dialog :visible.sync="updateUserPlotLimitDialogVisible"
                   width="40%"
                   :show-close="true"
                   :before-close="onUpdateUserPlotLimitDialogClose"
                   :close-on-click-modal="false"
                   center>
          <div class="dialog-main">
            <el-form :model="updatePlotLimitParams" label-width="110px" class="search-params-form">
              <el-form-item :label="updatePlotLimitParams.userName"/>
              <el-form-item label="地块数量上限：">
                <el-input placeholder="请输入地块个数" v-model="updatePlotLimitParams.plotNumberLimit" size="mini" clearable style="width:85%"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="onUpdateUserPlotLimitDialogClose()" type="primary">取消</el-button>
            <el-button @click="onUpdateUserPlotLimit()" type="primary">确定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { putRequest, getRequest } from 'utils/http-service'
import { URL_ACCOUNT, URL_ACCOUNT_PLOT_LIMIT, URL_ACCOUNT_TYPE, URL_ACCOUNT_EXPIRTY_TIME } from '../../constants/url'
import { UserStatusEnum } from '../../utils/UserStatusEnum'
import { UserTypesEnum } from '../../utils/UserTypesEnum'
import { formatTimeInSec, getStartTimestampOfDay } from 'utils/utils'

export default {
  name: 'account',
  data () {
    return {
      reqParams: {
        companyName: '',
        userName: '',
        userPhone: '',
        accountState: '',
        userType: '',
        page: 1,
        perPage: 10
      },

      staffInfoList: [],
      UserStatusArray: [],
      UserTypesArray: [],
      isLoading: false,
      total: 0,

      updateUserPlotLimitDialogVisible: false,
      updatePlotLimitParams: {
        userID: null,
        userName: null,
        plotNumberLimit: null
      },

      updateUserTypeDialogVisible: false,
      updateUserTypeParams: {
        userID: null,
        userName: null,
        userType: null
      },

      updateUserExpiryDialogVisible: false,
      updateUserExpiryParams: {
        userID: null,
        userName: null,
        expiryDate: null
      }
    }
  },

  methods: {
    getStaffInfoList () {
      this.isLoading = true
      let reqParams = this.reqParams
      let params = {
        orgName: reqParams.companyName,
        userName: reqParams.userName,
        phoneNumber: reqParams.userPhone,
        accountState: reqParams.accountState,
        userType: reqParams.userType,
        pageNumber: reqParams.page,
        pageSize: reqParams.perPage
      }

      getRequest(URL_ACCOUNT, params)
        .then(res => {
          if (res.code !== 0) {
            this.isLoading = false
            console.error(this.$route.name + 'getStaffInfoList() res', res)
            this.$message({ message: res.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            return
          }

          let dataList = []
          try {
            dataList = this._convertDto2Vo(res.data.pageData)
          } catch (error) {
            console.error(this.$route.name + '_convertDto2Vo() err', error)
          }

          if (!Array.isArray(dataList) || dataList.length === 0) {
            this.isLoading = false
            this.$message({
              showClose: true,
              message: '当前没有任何信息！',
              offset: 300,
              type: 'warning'
            })
            console.error(this.$route.name + ' getStaffInfoList() err: 当前没有任何信息！')
            this.staffInfoList = []
            this.total = 0
            return
          }

          this.staffInfoList = dataList
          this.total = res.data.totalRecordCount
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' getStaffInfoList() err', err)
          this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    _convertDto2Vo (dataList) {
      let vo = []

      dataList.forEach((item) => {
        let voItem = {
          userCompanyName: item.userCompanyName,
          userCompanyID: item.userCompanyID,
          userID: item.userID,
          userName: item.userName,
          userPhone: !item.phone ? '' : item.phone.replace(',', ''),
          accountState: item.accoutState,
          userType: item.userType,
          accountStateSummary: (item.accoutState || item.accoutState === 0) ? UserStatusEnum.getEnumByValue(Number(item.accoutState)).summaryCN : '',
          userTypeSummary: (item.userType || item.userType === 0) ? UserTypesEnum.getEnumByValue(Number(item.userType)).summaryCN : '',
          unavailableReason: item.unavailableReason,
          expiryDateStr: formatTimeInSec((item.expiryTimestamp || 0) / 1000, 'yyyy-MM-dd'),
          plotNumberLimit: item.plotNumLimit || 0
        }

        voItem.ableClose = voItem.accountState !== UserStatusEnum.CANCELLED.value
        voItem.ableSuspend = voItem.accountState === UserStatusEnum.AVAILABLE.value
        vo.push(voItem)
      })

      return vo
    },

    onSearch () {
      this.reqParams.page = 1
      this.getStaffInfoList()
    },

    onChangePager (newPage) {
      this.reqParams.page = newPage
      this.getStaffInfoList()
    },

    showUpdateUserTypeDialog (row) {
      this.updateUserTypeDialogVisible = true
      this.updateUserTypeParams.userID = row.userID
      this.updateUserTypeParams.userName = row.userName
      this.updateUserTypeParams.userType = row.userType
    },

    onUpdateUserTypeDialogClose () {
      this.updateUserTypeDialogVisible = false
    },

    onUpdateUserType () {
      const that = this

      console.log(that.$route.name + ' onUpdateUserType() ', that.updateUserTypeParams)
      if (!UserTypesEnum.getEnumByValue(that.updateUserTypeParams.userType)) {
        that.$message({ message: '请选择用户类型', showClose: true, offset: 300, type: 'error' })
        return
      }
      const userID = that.updateUserTypeParams.userID
      const userType = that.updateUserTypeParams.userType

      that.isLoading = true
      putRequest(URL_ACCOUNT_TYPE + '?userID=' + userID + '&userType=' + userType)
        .then(res => {
          that.isLoading = false
          if (res.code !== 0) {
            that.$message({ message: res.message || '修改失败，系统异常', showClose: true, offset: 300, type: 'error' })
            return
          }
          that.$message({ message: '修改成功', showClose: true, offset: 300, type: 'success' })
          that.onUpdateUserTypeDialogClose()
          for (let i = 0; i < that.staffInfoList.length; i++) {
            if (that.staffInfoList[i].userID === userID) {
              that.staffInfoList[i].userTypeSummary = UserTypesEnum.getEnumByValue(Number(userType)).summaryCN
              break
            }
          }
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' onUpdateUserType() err', err)
          that.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    showUpdateUserExpiryDialog (row) {
      this.updateUserExpiryDialogVisible = true
      this.updateUserExpiryParams.userID = row.userID
      this.updateUserExpiryParams.userName = row.userName
      this.updateUserExpiryParams.expiryDate = row.expiryTimestamp
    },

    onUpdateUserExpiryDialogClose () {
      this.updateUserExpiryDialogVisible = false
    },

    onUpdateUserExpiry () {
      const that = this

      console.log(that.$route.name + ' onUpdateUserExpiry() ', that.updateUserExpiryParams)
      if (!that.updateUserExpiryParams.expiryDate) {
        that.$message({ message: '请选择过期日期', showClose: true, offset: 300, type: 'error' })
        return
      }
      const userID = that.updateUserExpiryParams.userID
      const expiryTimestamp = getStartTimestampOfDay(new Date(that.updateUserExpiryParams.expiryDate).getTime())

      that.isLoading = true
      putRequest(URL_ACCOUNT_EXPIRTY_TIME + '?userID=' + userID + '&expiryTimestamp=' + expiryTimestamp)
        .then(res => {
          that.isLoading = false
          if (res.code !== 0) {
            that.$message({ message: res.message || '修改失败，系统异常', showClose: true, offset: 300, type: 'error' })
            return
          }
          that.$message({ message: '修改成功', showClose: true, offset: 300, type: 'success' })
          that.onUpdateUserExpiryDialogClose()
          for (let i = 0; i < that.staffInfoList.length; i++) {
            if (that.staffInfoList[i].userID === userID) {
              that.staffInfoList[i].expiryDateStr = formatTimeInSec(expiryTimestamp / 1000, 'yyyy-MM-dd')
              break
            }
          }
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' onUpdateUserExpiry() err', err)
          that.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    showUpdateUserPlotLimitDialog (row) {
      this.updateUserPlotLimitDialogVisible = true
      this.updatePlotLimitParams.userID = row.userID
      this.updatePlotLimitParams.userName = row.userName
      this.updatePlotLimitParams.plotNumberLimit = row.plotNumberLimit
    },

    onUpdateUserPlotLimitDialogClose () {
      this.updateUserPlotLimitDialogVisible = false
    },

    onUpdateUserPlotLimit () {
      const that = this

      console.log(that.$route.name + ' onUpdateUserPlotLimit() ', that.updatePlotLimitParams)
      if (isNaN(that.updatePlotLimitParams.plotNumberLimit) ||
          that.updatePlotLimitParams.plotNumberLimit < 0) {
        that.$message({ message: '地块数上限必须是正数', showClose: true, offset: 300, type: 'error' })
        return
      }
      const userID = that.updatePlotLimitParams.userID
      const plotNumberLimit = Math.ceil(that.updatePlotLimitParams.plotNumberLimit)

      that.isLoading = true
      putRequest(URL_ACCOUNT_PLOT_LIMIT + '?userID=' + userID + '&plotNumberLimit=' + plotNumberLimit)
        .then(res => {
          that.isLoading = false
          if (res.code !== 0) {
            that.$message({ message: res.message || '修改失败，系统异常', showClose: true, offset: 300, type: 'error' })
            return
          }
          that.$message({ message: '修改成功', showClose: true, offset: 300, type: 'success' })
          that.onUpdateUserPlotLimitDialogClose()
          for (let i = 0; i < that.staffInfoList.length; i++) {
            if (that.staffInfoList[i].userID === userID) {
              that.staffInfoList[i].plotNumberLimit = plotNumberLimit
              break
            }
          }
        })
        .catch(err => {
          that.isLoading = false
          console.error(that.$route.name + ' onUpdateUserPlotLimit() err', err)
          that.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    }
  },

  created () {
    let UserStatusArray = []
    let UserStatusEnumArray = UserStatusEnum.symbols()

    let UserTypesArray = []
    let UserTypesEnumArray = UserTypesEnum.symbols()

    UserStatusEnumArray.forEach(item => {
      UserStatusArray.push({value: item.value, label: item.summaryCN})
    })

    UserTypesEnumArray.forEach(item => {
      UserTypesArray.push({value: item.value, label: item.summaryCN})
    })

    this.UserStatusArray = UserStatusArray
    UserTypesArray.push({value: '', label: '所有用户'})
    this.UserTypesArray = UserTypesArray
    this.getStaffInfoList()
  }
}
</script>

<style lang="less" scoped>
.account-page-container {
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  padding: 15px 20px;
  .account-page-main {
    flex: 1;
    width:100%;
    height:100%;
    .account-page-body {
      display: flex;
      flex-direction: column;
      width:100%;
      height:100%;
      overflow-y: auto;
      /deep/ .el-card__header {
        padding: 14px 20px 4px;
        background-color: #fff;
      }
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        flex: 1;
        min-height: 280px;
        padding-top: 0;
        padding-bottom: 10px;
      }
      .search-params-form {
        width: 100%;
        height: 100%;
        .search-button {
          display: inline-block;
          margin-right: 70px;
        }
      }
      .account-card-body {
        width: 100%;
        height: 100%;
        flex: 1;
        .table-container {
          height: 100%;
        }
      }
      .footer {
        display: flex;
        justify-content: flex-end;
        height: 25px;
        margin-top: 15px;
      }
    }
    .dialog-container {
      .dialog-main {
        .search-params-form {
          .no-bottom-form-item {
            margin-bottom: 0;
          }
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account/index.vue